import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DistributorManagers } from 'types';

export const initialState: DistributorManagers = {
  loading: false,
  distributorManagerList: [],
  reset: false
};

const slice = createSlice({
  name: 'DistributorManagers',
  initialState,
  reducers: {
    setDistributorManagers: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.distributorManagerList = payload || [];
      state.reset = false;
    },
    reset: (state) => {
      state.reset = true;
    }
  }
});

export const { setDistributorManagers, reset } = slice.actions;

export default slice.reducer;
